import { createStyles, makeStyles } from '@mui/styles';
import { Theme } from '@mui/material';

export const useCartItemsStyles = makeStyles((theme: Theme) =>
  createStyles({
    card: {
      backgroundColor: '#fff',
      width: '97%',
      borderRadius: 16,
      marginBottom: theme.spacing(1.5),
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        marginBottom: 12,
      },
    },
    img: {
      maxHeight: 88,
      cursor: 'pointer',
    },
    contentWrapper: {
      display: 'flex',
      flexDirection: 'row',
      padding: '14px 0',
    },
    infoWrapper: {
      marginLeft: 12,
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      minWidth: 0,
    },
    cardTopRow: {
      display: 'flex',
      justifyContent: 'flex-end',
      width: '100%',
      marginBottom: 4,
      flexShrink: 0,
    },
    deleteButtonCorner: {
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
    },
    buttonsWrapper: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'end',
      minWidth: 160,
    },
    infoButtonsWrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      [theme.breakpoints.down('sm')]: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
      },
    },
    name: {
      fontSize: 20,
      fontWeight: 600,
      margin: 0,

      [theme.breakpoints.up('md')]: {
        fontSize: 34,
        lineHeight: 1,
      },
    },
    cardContent: {
      padding: '0 16px',
    },
    containerImage: {
      position: 'relative',
    },
    priceTotal: {
      color: '#181c32',
      fontSize: 17,
      fontWeight: '400',
    },
    priceProduct: {
      color: '#181c32',
      fontSize: 17,
      fontWeight: '400',
      marginRight: 8,
      whiteSpace: 'nowrap',
    },
    buttonDec: {
      cursor: 'pointer',
    },
    buttonCount: {
      color: '#181c32',
      borderColor: 'white',
      borderLeft: 'none',
      borderRight: 'none',
      margin: '0 2px',
      fontWeight: 400,
      fontSize: 17,
      minHeight: 40,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minWidth: 52,
      cursor: 'pointer',
    },
    buttonInc: {
      cursor: 'pointer',
    },
    productName: {
      fontSize: 17,
      lineHeight: 1.35,
      fontWeight: 400,
      color: '#181c32',
    },
    containerPrice: {
      display: 'flex',
      flexDirection: 'row',
      marginTop: 8,
      alignItems: 'center',
    },
    containerProduct: {
      display: 'flex',
      flexDirection: 'column',
      marginRight: 10,
    },
    btnIconTitle: {
      fontSize: 17,
      color: '#7c97c0',
      fontWeight: 400,
      marginLeft: 7,
    },
    containerButton: {
      cursor: 'pointer',
      marginBottom: 10,
    },
    containerBtns: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between',
      backgroundColor: '#a3a7b819',
      borderRadius: 4,
      marginLeft: 10,
      minHeight: 40,
      [theme.breakpoints.down('sm')]: {
        marginLeft: 0,
      },
    },
  })
);
